import { Linking } from 'react-native';

import { Text } from '@/components/text';
import { splitLinks } from '@/lib/linkify';

// Renders body text with http(s) URLs as tappable links that open
// externally. Returns a fragment so it drops into whatever Text/Paragraph
// the call site already uses -- no per-surface restyling.
//
// stopPropagation: a link inside a pressable card (thread rows) must open
// the link, not also navigate the card.
export function Linkified({
  children,
  linkColor = '$colorLink',
}: {
  children: string;
  // Override on a filled surface (own message bubble) where $colorLink
  // does not meet contrast; the underline still marks it as a link.
  linkColor?: '$colorLink' | '$colorOnAction';
}) {
  return (
    <>
      {splitLinks(children).map((segment, index) =>
        segment.type === 'link' ? (
          <Text
            key={index}
            accessibilityRole="link"
            color={linkColor}
            textDecorationLine="underline"
            hoverStyle={linkColor === '$colorLink' ? { color: '$colorLinkHover' } : undefined}
            onPress={(event) => {
              event.stopPropagation();
              void Linking.openURL(segment.value);
            }}
          >
            {segment.value}
          </Text>
        ) : (
          segment.value
        ),
      )}
    </>
  );
}
